"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _BottomNavigation.default;
  }
});

var _BottomNavigation = _interopRequireDefault(require("./BottomNavigation"));


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@material-ui+core@4.12.4_@types+react@19.0.10_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@material-ui/core/BottomNavigation/index.js
// module id = 569
// module chunks = 0